import { connect } from "react-redux";
import { RootState } from "../../../store/store";
import FormGroup from "../../../components/common/FormGroup";
import Select from "../../../components/common/controls/Select";
import ExampleSelectionFieldWithIcon from "./ExampleSelectionFieldWithIcon";
import microsoftExcelIcon from "static/images/microsoft-excel.svg";
import { DemoUsageType } from "../../../shared/enums/DemoUsageTypeEnum";
import SignInInstructionToDownloadExample from "./SignInInstructionToDownloadExample";

interface Props {
  demoExampleData: any[];
  logDownload: (demoId: string, usageType: DemoUsageType) => void;
  isAuthenticated?: boolean;
}

export function DownloadExcelExample(props: Props) {
  const { demoExampleData, logDownload, isAuthenticated } = props;
  const defaultText = "Please select an example here";

  const handleMicrosoftExcelSelectionChange = ({ selectedItem }: any) => {
    window.open(selectedItem.excelUrl, "_parent");
    logDownload(selectedItem.id, DemoUsageType.DownloadExcel);
  };

  const TextFieldWithExcelIcon = (data: any) => {
    return (
      <ExampleSelectionFieldWithIcon
        data={data}
        imageSource={microsoftExcelIcon}
        defaultText={defaultText}
      />
    );
  };

  return (
    <FormGroup label="Download example data for Excel:">
      {isAuthenticated ? (
        <Select
          dataSource={demoExampleData}
          displayExpr="title"
          valueExpr="id"
          className="h-12 w-88"
          fieldRender={TextFieldWithExcelIcon}
          onSelectionChanged={handleMicrosoftExcelSelectionChange}
        />
      ) : (
        <SignInInstructionToDownloadExample />
      )}
    </FormGroup>
  );
}

const mapStateToProps = (state: RootState, props: any) => {
  return {
    demoExampleData: state.demoData.demoExampleData,
    isAuthenticated: state.authData.isAuthenticated,
    ...props,
  };
};

export default connect(mapStateToProps)(DownloadExcelExample);
